import * as React from 'react'

export function Noop() {
  return <div className="hidden">noop</div>
}
